import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { first, map } from 'rxjs';

import { FirebaseService } from '../../shared/services/firebase.service';
import { authState } from '../services/auth.service';

export const RETURN_URL_KEY = 'returnUrl';

// eslint-disable-next-line func-style
export const authedGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const router = inject(Router);
	const auth = inject(FirebaseService).auth;

	return authState(auth).pipe(
		first(),
		map((user) => {
			if (!user) {
				const returnUrl = `${window.location.origin}${state.url}`;
				const redirectUrl = `/auth?${RETURN_URL_KEY}=${returnUrl}`;
				return router.parseUrl(redirectUrl);
			}
			return true;
		}),
	);
};
